export default __webpack_public_path__ + "static/media/upcoming_front.0b4d3bd3.svg";